import { HStack } from '@cdl/heartbeat-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { gainSelector } from '../../../layout/selectors/layout.selectors';
import { CanvasStrip } from '../../../plot/contexts/canvas-strip.context';
import { squareToPixel } from '../../../plot/utils/graph.utils';
import { setActiveTool } from '../../../tool/actions/tool.actions';
import { ClusterBeat } from '../../clustering.types';
import {
  clusterVerticalRangeSelector,
  projectedBaseClusterSelector,
} from '../../selectors/cluster.selectors';
import { OFFSET } from '../beatColumn/BeatStrip';
import { BeatMeasurement } from './BeatMeasurement';
import grid from '../../../../assets/images/grid.png';
import { InfoModal } from '../../../ecg/components/InfoModal';

interface Props {
  beat: ClusterBeat;
  onClose: () => void;
  modalOpen: boolean;
}

const WIDTH = squareToPixel(25);
const HEIGHT = squareToPixel(4.2);
export const BeatModal: React.FC<Props> = ({ beat, onClose, modalOpen }) => {
  const dispatch = useDispatch();
  const cluster = useSelector(projectedBaseClusterSelector);
  const gain = useSelector(gainSelector);
  const { yMin, yMax } = useSelector(clusterVerticalRangeSelector);

  const closeModal = useCallback(() => {
    onClose();
    dispatch(
      setActiveTool({
        tool: null,
        meta: { history: false },
      }),
    );
  }, [dispatch, onClose]);

  if (cluster == null) {
    return <></>;
  }

  return (
    <InfoModal
      title='Measure'
      isOpen={modalOpen}
      onClose={closeModal}
      size='4xl'
      closeButtonLabel='Close'
    >
      <HStack justifyContent='center'>
        <CanvasStrip
          clusterId={cluster.id}
          beats={[beat]}
          width={WIDTH}
          height={HEIGHT}
          xAxis={{ xMax: beat.data.length }}
          yAxis={{ yMin: yMin / gain, yMax: yMax / gain }}
          shadowBeats={undefined}
          offsetY={OFFSET}
        >
          <img
            src={grid}
            alt='grid'
            style={{
              position: 'absolute',
              width: WIDTH,
              height: HEIGHT + 2 * OFFSET,
            }}
          />
          <BeatMeasurement />
        </CanvasStrip>
      </HStack>
    </InfoModal>
  );
};
